var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriver24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4665 8.75H13.1332V7.25H9.4665V8.75ZM9.4665 6.5H13.1332V5H9.4665V6.5ZM2.8665 11H8.73317V10.5875C8.73317 10.025 8.46428 9.57813 7.9265 9.24688C7.38873 8.91563 6.67984 8.75 5.79984 8.75C4.91984 8.75 4.21095 8.91563 3.67317 9.24688C3.13539 9.57813 2.8665 10.025 2.8665 10.5875V11ZM5.79984 8C6.20317 8 6.54845 7.85313 6.83567 7.55938C7.12289 7.26562 7.2665 6.9125 7.2665 6.5C7.2665 6.0875 7.12289 5.73438 6.83567 5.44063C6.54845 5.14688 6.20317 5 5.79984 5C5.3965 5 5.05123 5.14688 4.764 5.44063C4.47678 5.73438 4.33317 6.0875 4.33317 6.5C4.33317 6.9125 4.47678 7.26562 4.764 7.55938C5.05123 7.85313 5.3965 8 5.79984 8ZM2.13317 14C1.72984 14 1.38456 13.8531 1.09734 13.5594C0.810115 13.2656 0.666504 12.9125 0.666504 12.5V3.5C0.666504 3.0875 0.810115 2.73438 1.09734 2.44063C1.38456 2.14687 1.72984 2 2.13317 2H13.8665C14.2698 2 14.6151 2.14687 14.9023 2.44063C15.1896 2.73438 15.3332 3.0875 15.3332 3.5V12.5C15.3332 12.9125 15.1896 13.2656 14.9023 13.5594C14.6151 13.8531 14.2698 14 13.8665 14H2.13317ZM2.13317 12.5H13.8665V3.5H2.13317V12.5Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver24Px);
export default __webpack_public_path__ + "static/media/driver_24px.19e20308a870f86e7b4980d35bc14ee3.svg";
export { ForwardRef as ReactComponent };